export const mediaChange = (query, handler) => {
  const handleChange = (e) => {
    if (e.matches) {
      handler();
    }
  };

  let watcher = window.matchMedia(query);
  watcher.addEventListener("change", handleChange);
};

export const showHideOverflowY = (bool) => {
  const body = document.body;
  if (bool) {
    body.style.overflowY = "hidden";
  } else {
    body.style.overflowY = "scroll";
  }
};
